export default [
 {
   "id": 1,
   "index_raster": 1,
   "nivell_2": 111,
   "categoria": "Conreus herbacis"
 },
 {
   "id": 2,
   "index_raster": 2,
   "nivell_2": 112,
   "categoria": "Horta, vivers i conreus forçats"
 },
 {
   "id": 3,
   "index_raster": 3,
   "nivell_2": 113,
   "categoria": "Vinyes"
 },
 {
   "id": 4,
   "index_raster": 4,
   "nivell_2": 114,
   "categoria": "Oliverars"
 },
 {
   "id": 5,
   "index_raster": 5,
   "nivell_2": 115,
   "categoria": "Altres conreus llenyosos"
 },
 {
   "id": 6,
   "index_raster": 6,
   "nivell_2": 116,
   "categoria": "Conreus en transformació"
 },
 {
   "id": 7,
   "index_raster": 7,
   "nivell_2": 221,
   "categoria": "Boscos densos d'aciculifolis"
 },
 {
   "id": 8,
   "index_raster": 8,
   "nivell_2": 222,
   "categoria": "Boscos densos de caducifolis, planifolis"
 },
 {
   "id": 9,
   "index_raster": 9,
   "nivell_2": 223,
   "categoria": "Boscos densos d'esclerofil·les i laurifolis"
 },
 {
   "id": 10,
   "index_raster": 10,
   "nivell_2": 224,
   "categoria": "Matollar"
 },
 {
   "id": 11,
   "index_raster": 11,
   "nivell_2": 225,
   "categoria": "Boscos clars d'aciculifolis"
 },
 {
   "id": 12,
   "index_raster": 12,
   "nivell_2": 226,
   "categoria": "Boscos clars de caducifolis, planifolis"
 },
 {
   "id": 13,
   "index_raster": 13,
   "nivell_2": 227,
   "categoria": "Boscos clars d'esclerofil·les i laurifolis"
 },
 {
   "id": 14,
   "index_raster": 14,
   "nivell_2": 228,
   "categoria": "Prats i herbassars"
 },
 {
   "id": 15,
   "index_raster": 15,
   "nivell_2": 229,
   "categoria": "Bosc de ribera"
 },
 {
   "id": 16,
   "index_raster": 16,
   "nivell_2": 230,
   "categoria": "Sòl nu forestal"
 },
 {
   "id": 17,
   "index_raster": 17,
   "nivell_2": 231,
   "categoria": "Zones cremades"
 },
 {
   "id": 18,
   "index_raster": 18,
   "nivell_2": 232,
   "categoria": "Roquissars i congestes"
 },
 {
   "id": 19,
   "index_raster": 19,
   "nivell_2": 233,
   "categoria": "Platges"
 },
 {
   "id": 20,
   "index_raster": 20,
   "nivell_2": 234,
   "categoria": "Zones humides"
 },
 {
   "id": 21,
   "index_raster": 21,
   "nivell_2": 341,
   "categoria": "Casc urbà"
 },
 {
   "id": 22,
   "index_raster": 22,
   "nivell_2": 342,
   "categoria": "Eixample"
 },
 {
   "id": 23,
   "index_raster": 23,
   "nivell_2": 343,
   "categoria": "Zones Urbanes laxes"
 },
 {
   "id": 24,
   "index_raster": 24,
   "nivell_2": 344,
   "categoria": "Edificacions aïllades en l'espai rural"
 },
 {
   "id": 25,
   "index_raster": 25,
   "nivell_2": 345,
   "categoria": "Àrees residencials aïllades"
 },
 {
   "id": 26,
   "index_raster": 26,
   "nivell_2": 346,
   "categoria": "Zones verdes"
 },
 {
   "id": 27,
   "index_raster": 27,
   "nivell_2": 347,
   "categoria": "Zones industrials , comercials i/o de serveis"
 },
 {
   "id": 28,
   "index_raster": 28,
   "nivell_2": 348,
   "categoria": "Zones esportives i de lleure"
 },
 {
   "id": 29,
   "index_raster": 29,
   "nivell_2": 349,
   "categoria": "Zones d'extracció minera i/o abocadors"
 },
 {
   "id": 30,
   "index_raster": 30,
   "nivell_2": 350,
   "categoria": "Zones en transformació"
 },
 {
   "id": 31,
   "index_raster": 31,
   "nivell_2": 351,
   "categoria": "Xarxa viària"
 },
 {
   "id": 32,
   "index_raster": 32,
   "nivell_2": 352,
   "categoria": "Sòl nu urbà"
 },
 {
   "id": 33,
   "index_raster": 33,
   "nivell_2": 353,
   "categoria": "Zones aeroportuàries"
 },
 {
   "id": 34,
   "index_raster": 34,
   "nivell_2": 354,
   "categoria": "Xarxa ferroviària"
 },
 {
   "id": 35,
   "index_raster": 35,
   "nivell_2": 355,
   "categoria": "Zones portuàries"
 },
 {
   "id": 36,
   "index_raster": 36,
   "nivell_2": 461,
   "categoria": "Embassaments"
 },
 {
   "id": 37,
   "index_raster": 37,
   "nivell_2": 462,
   "categoria": "Llacs i llacunes"
 },
 {
   "id": 38,
   "index_raster": 38,
   "nivell_2": 463,
   "categoria": "Cursos d'aigua"
 },
 {
   "id": 39,
   "index_raster": 39,
   "nivell_2": 464,
   "categoria": "Basses"
 },
 {
   "id": 40,
   "index_raster": 40,
   "nivell_2": 465,
   "categoria": "Canals artificials"
 },
 {
   "id": 41,
   "index_raster": 41,
   "nivell_2": 466,
   "categoria": "Mar"
 }
];